import React, { Component } from 'react';
import { connect } from 'react-redux';
import CredentialInputComponent from 'sub_components/Common/CredentialInputComponent';
import IconInputComponent from 'sub_components/Common/IconInputComponent';
import PasswordResetSuccess from 'sub_components/Login/PasswordResetSuccessNew';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import { enterNewPassword, confirmNewPassword, resetRegistrationState } from 'actions/registration';
import { MENU as PROFILE_MENU } from 'utils/ProfileConstants';
import { SITE_PAGES, SITE_MODULES } from 'utils/CommonConstants';
import { Divider } from 'styled_components/Common/Divider';
import format from 'date-fns/format';

const states = {
	NEW: 'NEW',
	CONFIRM: 'CONFIRM',
};
const numberRegex = /^.*[0-9].*$/;
const capitalLetter = /^.*[A-Z].*$/;

class PasswordChange extends Component {
	constructor(props) {
		super(props);

		this.validations = {
			'Must be at least 8 characters': /^.{8,}$/,
			'Must contain at least one number': numberRegex,
			'Must contain at least one capital letter': capitalLetter,
			'Must contain at least one special character': /[^A-Za-z0-9]+/,
			'Must only contain alphanumeric and special characters': /^[\S\T]+$/,
		};
		this.indicators = ['new_password_indicator', 'confirm_pwd_indicator'];
		this.inputs = { newInput: states.NEW, confirmInput: states.CONFIRM };

		this.state = {

			profile: this.props.profile,
			newPassword: '',
			status: null,
			newPasswordLength: null,
			showErrorMessage: false,
			currentLength: 0,
			error: false,
		};
	}

	receiveInput = input => {
		const { registration_status, enterNewPassword, confirmNewPassword } = this.props;
		const { newPassword } = this.state;
		const context = registration_status.context;

		if (context === 'NEW') {
			this.setState({ newPassword: input, newPasswordLength: input.length, currentLength: 0 });
			enterNewPassword(input);
		} else {
			confirmNewPassword(newPassword, input);
		}
	};

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.newPassword !== '') {
			if (nextProps.registration_status.status !== prevState.status) {
				return { status: nextProps.registration_status.status };
			}
		} else return null;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.registration_status.status !== prevState.status) {
			this.setState({ status: prevProps.registration_status.status });
		}
	}

	componentDidMount() {
		const { updateModule, updatePage } = this.props;

		updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.PASSWORD_CHANGE]);
		updateModule(SITE_MODULES.ACCOUNT);
	}

	checkRegistrationCompletion = () => {
		console.log('Checking for registration completion');
	};

	createValidations() {
		const { status, newPassword } = this.state;
		const newPwd = newPassword;
		const confirmPwdMatchRegex = new RegExp(
			`^${newPwd.replace(/[\[\[\\\^\$\.\|\?\*\+\(\)\]\+]/g, '\\$&')}$`,
		);
		const validations = {};

		if (status === 'NEW_PASSWORD_SUCCESS' && newPwd) {
			validations['Must match new password'] = confirmPwdMatchRegex;
		}

		return validations;
	}

	showErrorMessage = state => {
		this.setState({ showErrorMessage: state, currentLength: 0 });
	};

	resetPasswordSection = () => {
		const { resetRegistrationState, showErrorMessage } = this.props;

		if (!showErrorMessage) {
			this.showErrorMessage(true);
			setTimeout(() => {
				this.showErrorMessage(false);
				resetRegistrationState();
			}, 4000);
		}
	};

	resetRegistration = () => {
		const { resetRegistrationState } = this.props;
		const { error } = this.state;
		if (!error) {
			this.setState({ error: true, currentLength: 0 });
		}

		setTimeout(() => {
			resetRegistrationState();
			this.setState({ error: false });
		}, 2000);
	};

	onChangeCallback = input => {
		this.setState({ currentLength: input });
	};

	render() {
		const { status, newPasswordLength, showErrorMessage, currentLength, error } = this.state;
		const {
			setModalContent,
			registration_status,
			openMFAModal,
			auth_status: { user: { contactDetails, userProfile } = {} },
			setView,
		} = this.props;
		const mobile = contactDetails?.mobile_number;
		const secondFactorMethod = userProfile?.secondFactorMethod;

		return (
			<div className='password-change-new'>
				{status === 'CONFIRM_PASSWORD_SUCCESS' && (
					<PasswordResetSuccess modal={true} status={status} setModalContent={setModalContent} />
				)}
				{status === 'CONFIRM_PASSWORD_ERROR' && (
					<PasswordResetSuccess
						modal={true}
						status={status}
						resetRegistration={this.resetRegistration}
						setModalContent={setModalContent}
					/>
				)}
				{status === 'CONFIRM_PASSWORD_SUCCESS' && this.resetRegistration()}
				<div className='wrapper'>
					<div className='password-change-date'>
						<div className='label labels21'>PASSWORD CHANGE:</div>
						<div className='date body10'>{format(new Date(), 'MM / dd / yy')}</div>
					</div>
					<IconInputComponent showErrorMessage={showErrorMessage}>
						<div className='label labels21'>CHANGE PASSWORD:</div>
						<CredentialInputComponent
							error={error}
							initialPasswordLength={newPasswordLength}
							indicators={this.indicators}
							inputs={this.inputs}
							resetFields={this.resetPasswordSection}
							inputEnterCallback={this.receiveInput}
							checkCompletionCallback={this.checkRegistrationCompletion}
							inputLengthCallback={this.onChangeCallback}
							validationRules={{
								[states.NEW]: this.validations,
								[states.CONFIRM]: this.createValidations(),
							}}
							inputType={{ [states.NEW]: 'search', [states.CONFIRM]: 'search' }}
							status={registration_status}
							location='bottom'
							tooltipClassName='password-change-account'
						/>
						{currentLength >= 8 && !showErrorMessage && (
							<div className='confirm-text body10'>Press enter to confirm your password.</div>
						)}
						{currentLength <= 2 && status === 'NEW_PASSWORD_SUCCESS' && !showErrorMessage && (
							<div className='reenter-text body10'>
								Press re-enter your new password to confirm the change.
							</div>
						)}
					</IconInputComponent>

					<div className='password-change-date mfa'>
						<Divider />
						{mobile && (
							<div className='value-wrapper'>
								<div className='label labels21'>Mobile Number:</div>
								<div className='date body10 mfa' onClick={() => setView('details')}>
									{mobile}
								</div>
							</div>
						)}
						<div className='value-wrapper'>
							<div className='label labels21'>MFA:</div>
							{secondFactorMethod !== 'SMS' && (
								<div className='date body10 mfa' onClick={openMFAModal}>
									Enable MFA via SMS
								</div>
							)}
							{secondFactorMethod === 'SMS' && (
								<div className='date body10 mfa' onClick={openMFAModal}>
									Remove MFA via SMS
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		registration_status: state.registration_status,
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps, {
	enterNewPassword,
	confirmNewPassword,
	resetRegistrationState,
	updatePage,
	updateModule,
	addPageToBreadCrumbs,
})(PasswordChange);
